function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint react/no-did-update-set-state: "off" */
import React, { PureComponent } from 'react';
import classNames from 'classnames';
import { TableUtils } from '@deephaven/jsapi-utils';
import { Button, FadeTransition } from '@deephaven/components';
import AdvancedFilterCreatorSelectValueList from "./AdvancedFilterCreatorSelectValueList.js";
import "./AdvancedFilterCreatorSelectValue.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
class AdvancedFilterCreatorSelectValue extends PureComponent {
  constructor(props) {
    super(props);
    _defineProperty(this, "searchTablePromise", void 0);
    _defineProperty(this, "tableUtils", void 0);
    _defineProperty(this, "updateFilterTimer", void 0);
    this.handleSelectAllClick = this.handleSelectAllClick.bind(this);
    this.handleClearAllClick = this.handleClearAllClick.bind(this);
    this.handleListChange = this.handleListChange.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleUpdateFilterTimeout = this.handleUpdateFilterTimeout.bind(this);
    var dh = props.dh,
      invertSelection = props.invertSelection,
      selectedValues = props.selectedValues;
    this.tableUtils = new TableUtils(dh);
    this.state = {
      filters: [],
      invertSelection,
      selectedValues,
      searchText: ''
    };
  }
  componentDidMount() {
    this.initSearchTable();
  }
  componentDidUpdate(prevProps, prevState) {
    var _this$props = this.props,
      invertSelection = _this$props.invertSelection,
      selectedValues = _this$props.selectedValues,
      table = _this$props.table;
    if (prevProps.table !== table) {
      this.initSearchTable();
    }
    if (prevProps.invertSelection !== invertSelection) {
      this.setState({
        invertSelection
      });
    }
    if (prevProps.selectedValues !== selectedValues) {
      this.setState({
        selectedValues
      });
    }
    var _this$state = this.state,
      searchTable = _this$state.table,
      searchText = _this$state.searchText;
    if (searchTable !== prevState.table) {
      if (prevState.table != null) {
        prevState.table.close();
      }
      if (searchTable != null) {
        this.startUpdateFilterTimer();
      }
    }
    if (searchText !== prevState.searchText) {
      this.startUpdateFilterTimer();
    }
  }
  componentWillUnmount() {
    var table = this.state.table;
    if (table != null) {
      table.close();
    }
    this.searchTablePromise = undefined;
    this.stopUpdateFilterTimer();
  }
  getColumnName() {
    var table = this.props.table;
    if (table != null) {
      return table.columns[0].name;
    }
    return '';
  }
  getDisplayedValuesCount() {
    var _this$state2 = this.state,
      invertSelection = _this$state2.invertSelection,
      selectedValues = _this$state2.selectedValues,
      table = _this$state2.table;
    if (table == null) {
      return null;
    }
    if (invertSelection) {
      return table.totalSize - selectedValues.length;
    }
    return selectedValues.length;
  }
  getDisplayedValueText() {
    var count = this.getDisplayedValuesCount();
    var table = this.state.table;
    var formatter = this.props.formatter;
    if (count != null && table != null) {
      var formattedCount = formatter.getFormattedString(count, 'long');
      var formattedTableSize = formatter.getFormattedString(table.totalSize, 'long');
      var prefix = '';
      if (count < 1000000) {
        prefix = 'Displaying ';
      }
      return "".concat(prefix).concat(formattedCount, " of ").concat(formattedTableSize);
    }
    return null;
  }
  initSearchTable() {
    var table = this.props.table;
    if (table == null) {
      return;
    }
    var searchTablePromise = table.copy();
    this.searchTablePromise = searchTablePromise;
    this.searchTablePromise.then(searchTable => {
      if (this.searchTablePromise === searchTablePromise) {
        this.setState({
          table: searchTable
        });
        this.searchTablePromise = undefined;
      } else {
        searchTable.close();
      }
    });
  }
  handleListChange(selectedValues, invertSelection) {
    this.setState({
      selectedValues,
      invertSelection
    });
    var onChange = this.props.onChange;
    onChange(selectedValues, invertSelection);
  }
  handleSearchChange(event) {
    var searchText = event.target.value;
    this.setState({
      searchText
    });
  }
  handleSelectAllClick() {
    this.resetSelection(true);
  }
  handleClearAllClick() {
    this.resetSelection(false);
  }
  handleUpdateFilterTimeout() {
    this.updateFilterTimer = undefined;
    this.updateTableFilter();
  }
  resetSelection(invertSelection) {
    var selectedValues = [];
    this.setState({
      invertSelection,
      selectedValues
    });
    var onChange = this.props.onChange;
    onChange(selectedValues, invertSelection);
  }
  startUpdateFilterTimer() {
    this.stopUpdateFilterTimer();
    this.updateFilterTimer = setTimeout(this.handleUpdateFilterTimeout, AdvancedFilterCreatorSelectValue.searchDebounceTime);
  }
  stopUpdateFilterTimer() {
    if (this.updateFilterTimer != null) {
      clearTimeout(this.updateFilterTimer);
      this.updateFilterTimer = undefined;
    }
  }
  updateTableFilter() {
    var _this$state3 = this.state,
      table = _this$state3.table,
      searchText = _this$state3.searchText;
    var timeZone = this.props.timeZone;
    var tableUtils = this.tableUtils;
    var column = table === null || table === void 0 ? void 0 : table.columns[0];
    var filters = [];
    if (column == null) {
      return;
    }
    var error;
    if (searchText.length > 0) {
      var filter = null;
      if (TableUtils.isCharType(column.type)) {
        // Just exact match for char
        filter = tableUtils.makeQuickFilter(column, searchText);
      } else if (TableUtils.isTextType(column.type)) {
        // case insensitive & contains search text
        filter = tableUtils.makeQuickFilter(column, "~".concat(searchText), timeZone);
      } else {
        // greater than or equal search for everything else
        // we may want to be smarter with some other types (like dates)
        filter = tableUtils.makeQuickFilter(column, ">=".concat(searchText), timeZone);
      }
      if (filter != null) {
        filters.push(filter);
      } else {
        error = 'Invalid search text';
      }
    }
    this.setState({
      filters,
      error
    });
  }
  render() {
    var _this$state4 = this.state,
      error = _this$state4.error,
      filters = _this$state4.filters,
      invertSelection = _this$state4.invertSelection,
      selectedValues = _this$state4.selectedValues,
      searchText = _this$state4.searchText,
      table = _this$state4.table;
    var _this$props2 = this.props,
      dh = _this$props2.dh,
      formatter = _this$props2.formatter,
      showSearch = _this$props2.showSearch;
    var columnName = this.getColumnName();
    var displayedValuesText = this.getDisplayedValueText();
    var placeholderText = columnName ? "Find ".concat(columnName, "...") : '';
    return /*#__PURE__*/_jsxs("div", {
      className: "advanced-filter-creator-select-value",
      children: [/*#__PURE__*/_jsxs("div", {
        className: showSearch ? 'form-group' : '',
        children: [/*#__PURE__*/_jsx("label", {
          htmlFor: "advanced-filter-creator-select-value-input",
          children: "Select Values"
        }), showSearch && /*#__PURE__*/_jsx("input", {
          type: "text",
          className: classNames('form-control', {
            'is-invalid': error != null
          }),
          id: "advanced-filter-creator-select-value-input",
          placeholder: placeholderText,
          value: searchText,
          onChange: this.handleSearchChange
        })]
      }), /*#__PURE__*/_jsx(AdvancedFilterCreatorSelectValueList, {
        dh: dh,
        table: table,
        filters: filters,
        invertSelection: invertSelection,
        selectedValues: selectedValues,
        formatter: formatter,
        onChange: this.handleListChange
      }), /*#__PURE__*/_jsxs("div", {
        className: "advanced-filter-creator-select-meta-row",
        children: [/*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(Button, {
            kind: "ghost",
            onClick: this.handleSelectAllClick,
            children: "Select All"
          }), /*#__PURE__*/_jsx(Button, {
            kind: "ghost",
            onClick: this.handleClearAllClick,
            children: "Clear"
          })]
        }), /*#__PURE__*/_jsx(FadeTransition, {
          in: displayedValuesText != null,
          mountOnEnter: true,
          unmountOnExit: true,
          children: /*#__PURE__*/_jsx("div", {
            className: "row-count-info",
            children: displayedValuesText
          })
        })]
      })]
    });
  }
}
_defineProperty(AdvancedFilterCreatorSelectValue, "searchDebounceTime", 250);
_defineProperty(AdvancedFilterCreatorSelectValue, "defaultProps", {
  invertSelection: true,
  selectedValues: [],
  onChange: () => undefined,
  showSearch: true
});
export default AdvancedFilterCreatorSelectValue;
//# sourceMappingURL=AdvancedFilterCreatorSelectValue.js.map